<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div class="form-fieldhelp">
      <label>?</label>
      <div class="form-fieldhelp-text">
        <div>Например, номер и дата договора при его наличии, описание выполняемых на объекте работ</div>
      </div>
    </div>
    <label for="form-pass-additional-purpose" class="control-label">{{ inputLabel }}</label>
    <input
      class="form-control"
      id="form-pass-additional-purpose"
      autocomplete="off"
      v-model="inputValue"
      @input="emit"
      @change="emit"
      @blur="emit"
      :disabled="disabled"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'

export default {
  name: 'PassAdditionalPurposeInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Основание'
    },

    inputName: {
      default: 'additional_purpose'
    }
  }
}
</script>
